<section *ngIf="vm$ | async as vm" fxFlex class="material-story w-100" fxLayout="column" fxLayoutAlign="center stretch">
    <app-hero-title fxFlex fxHide.lt-sm="true" class="" title="Related Links"></app-hero-title>
    <div ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl" fxFlex class="links-content" fxLayout="row" fxLayoutAlign="center center" class="links-content">
        <ul fxFlex fxFlex.gt-sm="70">
            <li *ngFor="let link of vm.links">
                <a href="{{ link.content }}" target="_blank">{{ link.title }}</a>
            </li>
        </ul>
    </div>
</section>
